import { Inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Cell, Client } from "core-lib";
import { API_URL_TOKEN } from '../tokens/tokens';

const API_URL: string = 'https://api.h2delta.com/';

@Injectable({
    providedIn: 'root'
})
export class ClientService {

    constructor(
        private http: HttpClient,
        @Inject(API_URL_TOKEN) private API_URL: string
    ) { }

    get clients(): Observable<Client[]> {
        // return this.http.get<Client[]>('${API_URL}clients').pipe(map(clients => clients.filter(client => client.is_active === 'Y')));
        return this.http.get<Client[]>(`${this.API_URL}/clients`);
    }

    getCells(clientId: string): Observable<Cell[]> {
        return this.http.get<Cell[]>(`${this.API_URL}/client/${clientId}/cells`);
    }

    getClient(clientId: string): Observable<Client> {
        return this.http.get<Client>(`${this.API_URL}/client/${clientId}`);
    }

}
